var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.875 4c.31 0 .576.11.795.33.22.22.33.484.33.795v9c0 .31-.11.576-.33.795-.22.22-.484.33-.795.33h-1.872v-3.753H5.997v3.753H4.125c-.31 0-.576-.11-.795-.33-.22-.22-.33-.484-.33-.795v-9c0-.31.11-.576.33-.795.22-.22.484-.33.795-.33h15.75zm-3.05 4.175c.223.217.49.325.8.325.31 0 .576-.11.795-.33.22-.22.33-.484.33-.795 0-.31-.11-.576-.33-.795-.22-.22-.484-.33-.795-.33-.31 0-.576.11-.795.33-.22.22-.33.484-.33.795 0 .31.108.577.325.8zM16.5 13v7.664a.307.307 0 0 1-.11.238.39.39 0 0 1-.268.098H7.878a.39.39 0 0 1-.268-.098.307.307 0 0 1-.11-.238V13h9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.73e305c164de46db547247e7334ff4ea.svg";
export { ForwardRef as ReactComponent };